import React from 'react';

// Icons for the v2 inventory page (prototype paths). Always currentColor, so
// they follow the --v2-* text tokens.
const Svg = ({ size = 14, children }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false">
        {children}
    </svg>
);

export const SearchIcon = () => (
    <Svg size={15}><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" /></Svg>
);

export const FilterIcon = () => (
    <Svg size={13}><path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" /></Svg>
);

export const BoltIcon = () => (
    <Svg size={12}><path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" /></Svg>
);

export const TargetIcon = () => (
    <Svg size={12}><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 110-12 6 6 0 010 12zm0-3a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" /></Svg>
);

export const TaskIcon = () => (
    <Svg size={12}><path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></Svg>
);

export const OpenIcon = () => (
    <Svg>
        <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
        <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
    </Svg>
);

export const PlusIcon = () => (
    <Svg><path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" /></Svg>
);

export const CaretIcon = () => (
    <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true" focusable="false"><path d="M6 8L1 3h10z" /></svg>
);

export const ChevronLeft = () => (
    <Svg><path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" /></Svg>
);

export const ChevronRight = () => (
    <Svg><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" /></Svg>
);

export const ColumnsIcon = () => (
    <Svg size={13}><path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 1v10h2.5V5H5zm4.5 0v10h1V5h-1zm3 0v10H15V5h-2.5z" clipRule="evenodd" /></Svg>
);

export const ArrowUpIcon = () => (
    <Svg size={12}><path fillRule="evenodd" d="M10 4a1 1 0 01.707.293l5 5a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414l-3.293 3.293a1 1 0 01-1.414-1.414l5-5A1 1 0 0110 4z" clipRule="evenodd" /></Svg>
);

export const ArrowDownIcon = () => (
    <Svg size={12}><path fillRule="evenodd" d="M10 16a1 1 0 01-.707-.293l-5-5a1 1 0 011.414-1.414L9 12.586V5a1 1 0 112 0v7.586l3.293-3.293a1 1 0 011.414 1.414l-5 5A1 1 0 0110 16z" clipRule="evenodd" /></Svg>
);

export const GripIcon = () => (
    <Svg size={12}>
        <circle cx="7" cy="5" r="1.4" /><circle cx="13" cy="5" r="1.4" />
        <circle cx="7" cy="10" r="1.4" /><circle cx="13" cy="10" r="1.4" />
        <circle cx="7" cy="15" r="1.4" /><circle cx="13" cy="15" r="1.4" />
    </Svg>
);
